const DialogView = require('./dialog.html');

export const DialogDirective = [
  () => {
    return {
      restrict: 'E',
      transclude: true,
      scope: {instance: '=', disableClose: '='},
      templateUrl: DialogView,
      link: (scope, element, attrs) => {
        scope.hidden = true;
        scope.$watch('instance', value => {
          console.log('set tr instance');
          value.open = () => {
            scope.hidden = false;
          };
          value.close = () => {
            scope.hidden = true;
          };
        });

        scope.close = ($event) => {
          if (!scope.disableClose &&
            $event.target.classList.contains('tr-dialog-background')) {
            scope.hidden = true;
          }
        }
      },
    }
  }
];